<template>
  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >
        <LoginComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Login from "@/components/Login"
import {AUTH_SUCCESS} from "@/events/auth";
import {APP_INITIALIZE} from "@/store/modules/app/actions";

export default {
  name: "LoginView",
  components: {
    "LoginComponent": Login
  },
  methods: {
    onAuthSuccess() {
      this.$store.dispatch(APP_INITIALIZE)
    }
  },
  created() {
    this.$bus.$on(AUTH_SUCCESS, this.onAuthSuccess)
    /*if (this.$store.getters.isTokenOk)
        this.$router.push({name: "dashboard"})*/
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_SUCCESS, this.onAuthSuccess)
  }
}
</script>

<style scoped>

</style>